import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';

export function LegalDialogs() {
  return (
    <ul className="space-y-3 text-sm text-slate-400">
      <li>
        <Dialog>
          <DialogTrigger asChild>
            <button className="text-left text-sm text-slate-400 hover:text-white transition-colors">Política de Privacidad</button>
          </DialogTrigger>
          <DialogContent className="max-w-3xl border-slate-200">
            <DialogHeader>
              <DialogTitle className="text-2xl text-slate-900">Política de Privacidad</DialogTitle>
              <DialogDescription className="text-slate-500">
                Última actualización: {new Date().toLocaleDateString()}
              </DialogDescription>
            </DialogHeader>
            <ScrollArea className="h-[60vh] mt-4 pr-4">
              <div className="space-y-4 text-sm text-slate-600 leading-relaxed">
                <p>
                  En <strong>Free Zone Logistics Park</strong> valoramos y respetamos su privacidad. Esta política describe cómo recopilamos, utilizamos y protegemos la información personal que usted nos proporciona al interactuar con nuestro sitio web y servicios.
                </p>
                <h4 className="font-semibold text-slate-900 text-base mt-6">1. Información que recopilamos</h4>
                <p>
                  Recopilamos información de contacto básica, como su nombre, dirección de correo electrónico y número de teléfono, cuando usted llena nuestros formularios de contacto o se comunica con nosotros para solicitar información sobre nuestros espacios logísticos e infraestructura.
                </p>
                <h4 className="font-semibold text-slate-900 text-base mt-6">2. Uso de la información</h4>
                <p>
                  La información recopilada se utiliza exclusivamente para:
                  <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>Proveer la información solicitada sobre nuestros servicios y disponibilidad.</li>
                    <li>Contactarlo para dar seguimiento a sus consultas comerciales.</li>
                    <li>Mejorar la experiencia de usuario en nuestro sitio web.</li>
                  </ul>
                </p>
                <h4 className="font-semibold text-slate-900 text-base mt-6">3. Protección de datos</h4>
                <p>
                  Implementamos medidas de seguridad administrativas y técnicas para proteger su información personal contra pérdida, robo, acceso no autorizado o alteración. Sus datos no serán vendidos, alquilados ni compartidos con terceros sin su consentimiento explícito, salvo cuando sea requerido por la ley.
                </p>
                <h4 className="font-semibold text-slate-900 text-base mt-6">4. Contacto</h4>
                <p>
                  Si tiene preguntas sobre esta política de privacidad o desea ejercer sus derechos sobre sus datos personales, por favor contáctenos a través de nuestro formulario en línea o al correo electrónico proporcionado en la página.
                </p>
              </div>
            </ScrollArea>
          </DialogContent>
        </Dialog>
      </li>
      <li>
        <Dialog>
          <DialogTrigger asChild>
            <button className="text-left text-sm text-slate-400 hover:text-white transition-colors">Términos de Uso</button>
          </DialogTrigger>
          <DialogContent className="max-w-3xl border-slate-200">
            <DialogHeader>
              <DialogTitle className="text-2xl text-slate-900">Términos de Uso</DialogTitle>
              <DialogDescription className="text-slate-500">
                Última actualización: {new Date().toLocaleDateString()}
              </DialogDescription>
            </DialogHeader>
            <ScrollArea className="h-[60vh] mt-4 pr-4">
              <div className="space-y-4 text-sm text-slate-600 leading-relaxed">
                <p>
                  Al acceder y utilizar el sitio web de <strong>Free Zone Logistics Park</strong>, usted acepta estar sujeto a los siguientes Términos de Uso. Si no está de acuerdo con estos términos, le rogamos que no utilice nuestro sitio.
                </p>
                <h4 className="font-semibold text-slate-900 text-base mt-6">1. Uso del Sitio Web</h4>
                <p>
                  El contenido de este sitio web es proporcionado con fines informativos sobre nuestra infraestructura, parques logísticos y servicios asociados en la Zona Libre de Colón, Panamá. Nos reservamos el derecho de modificar o actualizar la información del sitio web en cualquier momento sin previo aviso.
                </p>
                <h4 className="font-semibold text-slate-900 text-base mt-6">2. Propiedad Intelectual</h4>
                <p>
                  Todos los derechos de propiedad intelectual del contenido, diseño, textos, gráficos, imágenes y código fuente de este sitio web son propiedad exclusiva de Free Zone Logistics Park o se utilizan bajo licencia. Queda estrictamente prohibida su reproducción, distribución o modificación no autorizada.
                </p>
                <h4 className="font-semibold text-slate-900 text-base mt-6">3. Limitación de Responsabilidad</h4>
                <p>
                  La información sobre áreas, disponibilidad, especificaciones de construcción y servicios está sujeta a cambios. Free Zone Logistics Park no se hace responsable por decisiones comerciales tomadas basándose únicamente en la información de este sitio web. Le recomendamos contactar a nuestro equipo comercial para confirmar detalles y recibir asesoría personalizada.
                </p>
                <h4 className="font-semibold text-slate-900 text-base mt-6">4. Ley Aplicable</h4>
                <p>
                  Estos términos se regirán e interpretarán de acuerdo con las leyes de la República de Panamá. Cualquier controversia será sometida a la jurisdicción exclusiva de los tribunales panameños.
                </p>
              </div>
            </ScrollArea>
          </DialogContent>
        </Dialog>
      </li>
    </ul>
  );
}
